const driversOnline = {
  driversOnline: 'Online Drivers',

  table: {
    headers: {
      name: 'Name',
      phone: 'Phone number',
      status: 'Status',
      vehicle: 'Vehicle',
      activeSince: 'Active Since',
      sum: 'Sum',
      pax: 'Pax',
      earned: 'Earned',
    },
    driverStatusOptions: {
      online: 'Online',
      enRoute: 'En Route',
      break: 'Break',
      endBreak: 'End Break',
    },
    actions: {
      deactivate: 'Suspend',
    },
  },

  form: {
    fields: {
      driver: 'Driver',
      vehicle: 'Vehicle',
    },
    activateButton: 'Go Online',
  },

  deactivateModal: {
    header: 'Deactivate driver',
    body: 'Are you sure you want to deactivate {{driver}}?',
  },
  breakModal: {
    header: 'Break driver',
    body: 'Are you sure you want to release {{driver}} for a break?',
  },
};

export default driversOnline;
